import { Button, Col, Form, Modal, Row, Upload } from "antd";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import NormalForm from "./NormalForm";
import QRCode from "qrcode";
import { io } from "socket.io-client";
import config from "../../../../config";
import { getAsset } from "../../../../services/general";

const DrugForm = ({
  form,
  inputs,
  patient,
  disableForm,
  admissionPatientExamId,
  drugModal,
  setDrugModal,
  drugState,
  setDrug,
  fetchInputs,
  roles,
  fileList,
  status,
  setRefresh,
  removeDocument,
  convertFile,
  convertError,
  isDICOM,
  handleConvertFile,
  imageUrl,
  setImageUrl,
  countrySettings,
  fromExternal,
}) => {
  const [imageState, setImage] = useState(true);
  const [sampleImage, setSampleImage] = useState();
  const qrRef = useRef();

  useEffect(() => {
    if (qrRef.current && drugModal && patient?.patient_name) {
      QRCode.toCanvas(
        qrRef.current,
        `${admissionPatientExamId}\n${patient.patient_name}\n${moment().format('HH:mm:ss')}`,
      );
    }
  }, [drugModal, admissionPatientExamId, patient?.patient_name]);

  useEffect(() => {
    const newSocket = io(config.apiDrug);
    const socketType = `drugs-${admissionPatientExamId}`;
    newSocket.on(socketType, (message, callback) => {
      if (message && inputs.procedures) {
        setRefresh(Date.now());
        window.location.reload();
      }
      callback(true);
    });
    return () => newSocket.close();
  })

  useEffect(() => {
    const showSample = async () => {
      const sampleProcedure = inputs.procedures.find(procedure => procedure.blocked);
      if (!Object.keys(fileList).includes(sampleProcedure.id.toString())) {
        const sampleUrl = await getAsset({
          field: 'document',
          id: sampleProcedure.result_id,
          type: 'AdmissionProcedureResult',
        });
        setSampleImage(sampleUrl)
      } else if (fileList && fileList.length > 0 && fileList[sampleProcedure.id.toString()].length > 0 && !sampleImage) {
        setSampleImage({
          document_url: fileList[sampleProcedure.id.toString()][0].url,
        })
      }
    }

    if (inputs.procedures.find(procedure => procedure.blocked && procedure.result_id)) {
      showSample();
    }
  }, [fileList, inputs.procedures]);

  const handleManualClose = () => {
    setImage(true);
    setDrugModal(false);
  };

  const handleFinish = () => {
    setImage(false);
    setDrugModal(false);
    if (drugState.length) setDrug([]);
  }

  return (
    <Row justify="center">
      {
        inputs.procedures.find(procedure => procedure.blocked && procedure.result_id) && sampleImage?.document_url &&
        <Col>
          <img src={sampleImage.document_url} alt="muestra" width={800} />
        </Col>
      }
      <Col lg={24}>
        <NormalForm
          form={form}
          inputs={inputs}
          disableForm={disableForm}
          roles={roles}
          status={status}
          removeDocument={removeDocument}
          convertFile={convertFile}
          convertError={convertError}
          isDICOM={isDICOM}
          handleConvertFile={handleConvertFile}
          imageUrl={imageUrl}
          setImageUrl={setImageUrl}
          countrySettings={countrySettings}
          fromExternal={fromExternal}
        />
      </Col>
      {
        imageState &&
        <Col lg={24}>
          <Form.Item
            label='Imagen de la muestra'
            required={true}
          >
            <Upload.Dragger
              disabled={disableForm}
              onRemove={() => {
                setDrug([]);
              }}
              beforeUpload={file => {
                setDrug([file]);
                return false;
              }}
              fileList={drugState}
            >
              <p className="ant-upload-text">Presione o arrastre su documento a esta área para subirlo</p>
            </Upload.Dragger>
          </Form.Item>
        </Col>
      }
      <Modal
        className="modal-drug"
        centered={true}
        visible={drugModal}
        onCancel={handleManualClose}
        cancelText="Cerrar"
        footer={false}
        width='50%'
      >
        <Row gutter={[0, 15]} className='mb-40 mt-40'>
          <Col lg={24}>
            <Row justify="center">
              <Col>
                <h2>Carga de datos</h2>
              </Col>
            </Row>
          </Col>
          <Col lg={24}>
            <Row justify="center">
              <Col>
                <canvas ref={qrRef} />
              </Col>
            </Row>
          </Col>
          <Col lg={24}>
            <Row justify="center">
              <Col>
                <p className="mb-0">Escanee el código QR con el lector de muestras</p>
              </Col>
            </Row>
            <Row justify="center">
              <Col>
                <p>y presione Finalizar carga QR</p>
              </Col>
            </Row>
          </Col>
          <Col lg={24}>
            <Row justify="center" gutter={15}>
              <Col lg={6}>
                <Button
                  className="cmt-button primary outline"
                  type="primary"
                  size="large"
                  onClick={handleManualClose}
                >
                  Carga manual
                </Button>
              </Col>
              <Col lg={6}>
                <Button
                  className="cmt-button primary"
                  type="primary"
                  size="large"
                  onClick={handleFinish}
                >
                  Finalizar carga QR
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal>
    </Row>
  )
}

export default DrugForm;